import { attendeeFetchData } from "./index";

const commonAPI = {
  fetchStates: () => attendeeFetchData(`/api/v2/states`),
  fetchDisciplines: () => attendeeFetchData(`/api/v2/disciplines`),
}

export default commonAPI;
